import { abortableFetch, useEventCallback } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useDeleteLegalAdviserDialog() {
  const callApi = useEventCallback((id: string, legalAdviserId: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.ES_FILES}/${id}/participant/${legalAdviserId}`,
      {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
  });

  return {
    callApi,
  };
}
